import { useMemo } from "react";
import { useItems } from "./useItems.js";
import { useActiveCompany } from "../../../shared/context/ActiveCompanyContext.jsx";
import { itemInCompany } from "../models/item.js";

/**
 * Items of the working company (selected in the header).
 * An item can belong to multiple companies or all companies.
 */
export function useCompanyItems() {
  const itemApi = useItems();
  const { activeCompanyId } = useActiveCompany();

  const items = useMemo(
    () => (itemApi.items || []).filter((item) => itemInCompany(item, activeCompanyId)),
    [itemApi.items, activeCompanyId]
  );

  return {
    ...itemApi,
    allItems: itemApi.items,
    items,
    activeCompanyId
  };
}

export default useCompanyItems;
